module.exports = __webpack_public_path__ + "img/IMG-Vendor-bg1.c8f524fe.png";